var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navi-block",class:{
        active: _vm.is_active,
        'mark-clickable':
            (_vm.is_active == false || _vm.forceNavigation == true) && _vm.navigate,
    },on:{"click":_vm.doNavigation}},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.is_active)?_c('div',{staticClass:"navi-block__shadow"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }